<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			text: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<p use:editable={content} class="text-[20px]/[140%] tracking-[-.2px] text-brown-1">{content.text}</p>
